/**
 * Cihazdan GPS konumu alır ve kabin işlemleri için sunucuya mesafe sorar.
 *
 * Kabin taşıma (form 75, FormikKonumField) ve Kurulum Tamamla aynı kuralı
 * kullanır: işlem yalnızca kabinin bulunduğu lokasyona 100 m içinden yapılır
 * (backend/services/konum_dogrulama.py). Buradaki kontrol yalnızca bilgi
 * amaçlıdır; kararı kayıt anında sunucu verir.
 *
 * 03.11.2026: Harcırah günlük konum doğrulaması da cihazKonumuAl'ı kullanır
 * (seyahatin ilinin sınırları içinde mi; components/harcirah/BenimHarcirahim.jsx).
 *
 * Not: navigator.geolocation yalnızca HTTPS (veya localhost) üzerinde çalışır.
 */
import dayjs from 'dayjs';
import { API_BASE_URL } from './config';

const HATA = {
  1: 'Konum izni reddedildi. Tarayıcı ayarlarından bu siteye konum izni verin.',
  2: 'Konum bilgisi alınamadı.',
  3: 'Konum isteği zaman aşımına uğradı.',
};

/** Alanlar kabin_tasima kolonlarıyla aynı adı taşır. */
export const cihazKonumuAl = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) {
    reject(new Error('Tarayıcı konum desteği yok.'));
    return;
  }
  navigator.geolocation.getCurrentPosition(
    ({ coords }) => resolve({
      enlem: Number(coords.latitude.toFixed(7)),
      boylam: Number(coords.longitude.toFixed(7)),
      konum_dogruluk: Math.round(coords.accuracy),
      konum_kaynak: 'gps',
      konum_tarihi: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    }),
    (err) => reject(new Error(HATA[err.code] || 'Konum alınamadı.')),
    { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
  );
});

/**
 * `hedef`: { kabin } (kabinin şu anki yeri) ya da { lokasyon }.
 * Dönüş: { gecerli, mesaj, mesafe_m, lokasyon_ad } — istek başarısızsa null.
 */
export const konumKontrol = async (konum, hedef) => {
  const params = new URLSearchParams({
    enlem: konum.enlem,
    boylam: konum.boylam,
    dogruluk: konum.konum_dogruluk,
  });
  Object.entries(hedef).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') params.set(k, v);
  });
  try {
    const res = await fetch(`${API_BASE_URL}/form/konum-kontrol?${params}`);
    return res.ok ? await res.json() : null;
  } catch (e) {
    return null;
  }
};
